// extracted by mini-css-extract-plugin
export default {"container":"index-module__container___Tb4r8","status":"index-module__status____GUoB"};